export default __webpack_public_path__ + "72f0fcc793eda19cdc1604efc3b381cb.svg";